import React, { useState, useEffect  } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // <-- IMPORTANTE
import { Navbar, Nav } from 'react-bootstrap';
import { FaTachometerAlt, FaCheckSquare, FaSignOutAlt, FaBars } from 'react-icons/fa';
import logoUltra from './logoUtra.jpeg';

function Sidebar({ children }) {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const navigate = useNavigate(); // <-- IMPORTANTE
 // Verifica se a matrícula existe na sessionStorage
 useEffect(() => {
  const matricula = sessionStorage.getItem('matricula');
  if (!matricula) {
    navigate('/'); // redireciona para o login se não tiver a variável
  }
}, [navigate]);

  const toggleSidebar = () => setIsNavExpanded(!isNavExpanded);
  
  return (
    <div>
      {/* Botão para abrir o menu no mobile */}
      <div className="menuMobile d-lg-none  bg-light shadow-sm position-fixed " style={{ zIndex: 1040 }}>
        <FaBars size={24} onClick={toggleSidebar} />
      </div>

      {/* Sidebar */}
      <div
        className={`sidebar ${isNavExpanded ? 'open' : ''} d-lg-block`}
        style={{
          boxShadow: '0px 0px 8px 0px #9E9E9E',
          width: 200,
          position: 'fixed',
          height: '100%',
          top: 0,
          left: 0,
          backgroundColor: '#f8f9fa'
        }}
      >
        <div>
          <Navbar.Brand as={Link} to="/" className="p-3 d-block">
            <img src={logoUltra} alt="Logo Ultra" className="img-fluid" />
          </Navbar.Brand>
          <Nav className="flex-column px-3">
            <Nav.Link as={Link} to="/amigofarma" onClick={() => setIsNavExpanded(false)}>
              <FaTachometerAlt size={20} /> Amigo Farma
            </Nav.Link>
            <Nav.Link as={Link} to="/naovendi" onClick={() => setIsNavExpanded(false)}>
              <FaCheckSquare size={20} /> Não Vendi
            </Nav.Link>
            <Nav.Link as={Link} to="/relatorionaovendi" onClick={() => setIsNavExpanded(false)}>
              <FaCheckSquare size={20} /> Relatório Não Vendi
            </Nav.Link>
            <Nav.Link as={Link} to="/relatorionps" onClick={() => setIsNavExpanded(false)}>
              <FaCheckSquare size={20} /> Relatório Nps
            </Nav.Link>
            <Nav.Link
  as={Link}
  to="/"
  onClick={() => {
    sessionStorage.clear();
    setIsNavExpanded(false);
  }}
>
  <FaSignOutAlt size={20} /> Sair
</Nav.Link>

          </Nav>
        </div>
      </div>

      {/* Conteúdo principal */}
      <div
        className="main-content"
        style={{
          marginTop: '10px',
          marginLeft: window.innerWidth >= 992 ? '200px' : '0',
          padding: '20px'
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default Sidebar;
